/**
 * Risk assessment scoring for Change Control (CC).
 *
 * Mirrors the IMPACT_LIST in ControlRiskView: 5 Yes/No questions, each with a
 * level (1 or 2). Score = sum of levels for answered "Yes".
 * Grading: score >= 2 → 'high', score === 1 → 'medium', else 'low'.
 */

const IMPACT_LEVELS = {
  riskSpecification: 1,
  riskManagement: 1,
  riskRegulations: 2,
  riskSafety: 2,
  riskProcess: 1,
};

export function computeRiskScore(form = {}) {
  return Object.entries(IMPACT_LEVELS).reduce(
    (score, [key, level]) => score + (form[key] === 1 ? level : 0),
    0
  );
}

export function deriveRiskGrading(score) {
  return score >= 2 ? 'high' : score === 1 ? 'medium' : 'low';
}
